import { useNavigate } from 'react-router';
import { Link } from '#components/atoms/link/Link.tsx';
import { MainLayout } from '#components/patterns/layouts/main/MainLayout.tsx';
import { PageCloser } from '#components/patterns/page-closer/PageCloser.tsx';
import { PageHeader } from '#components/patterns/page-header/PageHeader.tsx';
import { UpsellModal } from '#components/patterns/upsell-modal/UpsellModal.tsx';
import { useAuth } from '#global/context/auth/useAuth.tsx';
import { useAppLocation } from '#hooks/useAppLocation.ts';
import { RoutesPage } from '#screens/routes/routes-page/RoutesPage.tsx';
import { fromArray, Titled } from '#util/title.ts';
import { RouteForm } from '../form/RouteForm.tsx';
import { TooManyRoutesModal } from './TooManyRoutesModal.tsx';
import { useSuspenseIsRoutesLimitReached } from './useSuspenseIsRoutesLimitReached.ts';

export function AddRoutePage() {
  const navigate = useNavigate();
  const location = useAppLocation();
  const plan = useAuth().user?.organization.plan;
  const { isLimitReached, routesLimit } = useSuspenseIsRoutesLimitReached();

  function returnToList() {
    void navigate(location.state?.from ?? '/routes');
  }

  return (
    <Titled title={(title) => fromArray(['Add Route', title])}>
      {isLimitReached ?
        plan === 'free' ?
          <>
            <RoutesPage />
            <UpsellModal onClose={returnToList} />
          </>
        : <TooManyRoutesModal onClose={returnToList} routesLimit={routesLimit} />
      : <MainLayout
          header={
            <PageHeader
              title={
                <>
                  <Link to="/routes" className="a">
                    Routes
                  </Link>
                  {' / '}
                  Add
                </>
              }
            >
              <PageCloser fallbackTo="/routes" />
            </PageHeader>
          }
        >
          <RouteForm
            routeId={null}
            onSuccess={() => {
              void navigate(location.state?.from ?? '/routes', { replace: true });
            }}
          />
        </MainLayout>
      }
    </Titled>
  );
}
